import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';
import {CommonConstant} from '../../app.constants';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {UserService} from '../../services/user.service';
import {AuthService} from '../../core/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
  ActivePages, EventTrackerService, Page,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.scss']
})
export class ConfirmPasswordComponent implements OnInit {

  user: FormGroup;
  private userData;
  private linkInvitationExpired = false;
  private hashKey: string;
  errorMessage: string;

  private passwordControl = new FormControl(undefined, {
    validators: this.validatePassword.bind(this),
    updateOn: 'blur'
  });

  private confirmPasswordControl = new FormControl(undefined, {
    validators: this.validatePassword.bind(this),
    updateOn: 'blur'
  });

  constructor(private placeholderService: PlaceholderVisibilityService,
              private userService: UserService,
              private router: Router,
              private eventTracker: EventTrackerService,
              private activatedRoute: ActivatedRoute,
              private auth: AuthService) { }

  validatePassword() {
    if (!this.user) {
      return null;
    }
    const newPassword = this.user.controls.newPassword.value;
    const confirmPassword = this.user.controls.confirmPassword.value;
    if (!confirmPassword && !newPassword) {
      return null;
    }

    if (confirmPassword !== newPassword) {
      return {
        doesMatchPassword: false
      };
    }
    return null;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(res => {
      this.hashKey = res.hashKey;
      this.userService.precheckHashLink(res.hashKey).subscribe((user) => {
        this.userData = user;
      }, err => {
        this.errorMessage = err.error.message;
        this.linkInvitationExpired = true;
        this.user.controls['newPassword'].disable();
        this.user.controls['confirmPassword'].disable();
      });
      this.user = new FormGroup({
        newPassword: this.passwordControl,
        confirmPassword: this.confirmPasswordControl,
      });
      this.confirmPasswordControl.valueChanges.subscribe((evt) => {
        if (evt) {
          this.passwordControl.updateValueAndValidity();
        }
      });
    });
  }

  onSubmit({ value, valid }: {value: any, valid: boolean}) {
    if (valid) {
      this.placeholderService.show(CommonConstant.LOGIN_PLACEHOLDER);
      const data = {
        hashString: this.hashKey,
        userEmail:  this.userData.email,
        newPassword: value.newPassword
      };
      this.userService.resetPassword(data).subscribe(() => {
        this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
        this.auth.login(this.userData.email, value.newPassword, () => {
          this.auth.getUserData(user => {
            this.eventTracker.hasIdentifiedObserver.subscribe((res: any) => {
              if (res) {
                this.eventTracker.trackUserAction(UserActionType.LOGIN, Page.LOGIN, undefined, undefined, undefined, {
                  type: ActivePages.LOGIN,
                });
              }
            });
            if (!this.userService.getCompanyId()) {
              this.userService.loadAccountListByUser(this.auth.getUser(), () => {
                this.router.navigate(['/discover']);
              });
            } else {
              this.router.navigate(['/discover']);
            }
          });
        });
      }, err => {
        this.errorMessage = err.error.message;
        this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
      });
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/confirm-password/confirm-password.component.ts